import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "openweathermap-state-config"
  }, [_c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n    " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.openweathermapSelectText')) + "\n  ")]), _c(VRow, [_c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VDataTable, {
    attrs: {
      "headers": _vm.variableTableHeader,
      "items": _vm.weatherVariables,
      "single-select": _vm.mode !== 'import',
      "item-key": "variable",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n          ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedWeatherVariable,
      callback: function ($$v) {
        _vm.selectedWeatherVariable = $$v;
      },
      expression: "selectedWeatherVariable"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };